import { useMediaQuery, useTheme } from '@mui/material';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import { User } from '@src/main/modules/common/user/domain/User';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';
import { useEffect, useState } from 'react';

export const useGetDashboardsToShowByMediaQuery = (
  dashboards: Dashboard[],
  isExpanded: boolean,
  isExpandable: boolean,
) => {
  const theme = useTheme();
  const { user } = useUserContext();
  const [dashboardsToShow, setDashboardsToShow] = useState<Dashboard[]>([]);
  const is2columns = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const is3columns = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
  const is4columns = useMediaQuery(theme.breakpoints.up('xl'));

  const dashboardsToShowByMediaQuery = dashboards.slice(
    0,
    getNumberOfColumns(is2columns, is3columns, is4columns),
  );

  const isShowAllVisible = !isExpanded && dashboardsToShowByMediaQuery.length < dashboards.length;
  const isCollapseVisible = isExpandable && dashboardsToShowByMediaQuery.length < dashboards.length;

  useEffect(() => {
    if (user) {
      setDashboardsToShow(
        filterDashboards(
          !isExpandable || isExpanded ? dashboards : dashboardsToShowByMediaQuery,
          user,
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, dashboards]);

  return {
    dashboardsToShow,
    isShowAllVisible,
    isCollapseVisible,
  };
};

const getNumberOfColumns = (
  is2columns: boolean,
  is3columns: boolean,
  is4columns: boolean,
): number => {
  if (is2columns) return 2;
  if (is3columns) return 3;
  if (is4columns) return 4;
  return 1;
};

const filterDashboards = (dashboards: Dashboard[], user: User): Dashboard[] => {
  const isAdmin = user.roles.includes('ADMIN');

  return dashboards.filter((dashboard) => {
    if (dashboard.isShowAll) {
      return true;
    }
    if (!dashboard.isShowAll && isAdmin) {
      return true;
    }
    if (!dashboard.isShowAll && dashboard.haveAccess) {
      return true;
    }
    return false;
  });
};
